"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootContainer = void 0;

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var RootContainer =
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-19he4va0"
})("position:fixed;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,0.1);z-index:1000;");
exports.RootContainer = RootContainer;